import { useMutation } from '@tanstack/react-query';
import { Order } from 'types/order';
// import { Payment } from 'api/payment';
import { client } from './api-client';

const useOrder = () =>
  useMutation<string, unknown, Order>((data) =>
    client(`/megr/order`, { data, method: 'post' })
  );

export { useOrder };
